import ToggleSwitch from "../ToggleSwitch";

const HighSeverityFlag = ({
  name,
  value,
  onChange,
  disabled,
}: {
  name: string;
  value: boolean;
  onChange: () => void;
  disabled: boolean;
}) => {
  return (
    <div className="mt-2 flex items-center justify-between">
      <ToggleSwitch
        name={name}
        label={"Mark as high severity"}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default HighSeverityFlag;
